import { render, staticRenderFns } from "./ReporteDespachos.vue?vue&type=template&id=0df981dc&scoped=true"
import script from "./ReporteDespachos.vue?vue&type=script&lang=js"
export * from "./ReporteDespachos.vue?vue&type=script&lang=js"
import style0 from "./ReporteDespachos.vue?vue&type=style&index=0&id=0df981dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df981dc",
  null
  
)

export default component.exports